export const riskProfileOptions = ['core', 'core_plus', 'value_add', 'opportunistic'];
